import { JurisdictionContext } from '@/data';
import { getAllBets } from '@/feature/bets-sbk/hooks/use-bets';
import { SBK_BETSLIP_LOG_TAG } from '@/feature/betslip-sbk/hooks/use-sbk-betslip-store';
import { ConfirmedBetMapping } from '@/feature/betslip-sbk/types';
import { logger } from '@/utils/logging';

// Helper delay function
export const delay = (ms: number) => new Promise(res => setTimeout(res, ms));

// fetch open bets from /auth/bets endpoint, check if all submitted bets are in open bets
// /auth/bets is filtered by the exact site behind the header, so the poll must reuse the submission's context
export const pollSubmittedBets = async (
    submittedBetIds: string[],
    context: JurisdictionContext
): Promise<{ success: boolean; betIdMapping: ConfirmedBetMapping }> => {
    let success = false;
    // `every` is vacuously true on an empty list, which would confirm a placement that never submitted
    if (submittedBetIds.length === 0) {
        return { success, betIdMapping: {} };
    }
    try {
        const openBets = await getAllBets({ tab: 'Open' }, context);
        const allBetSubmitted = submittedBetIds.every(betId => {
            return openBets.data.find(bet => bet.bet_producer_id === betId);
        });
        if (allBetSubmitted) {
            success = true;
            // maps the submitted bet id => global bet id and confirmed position fill
            const betIdMapping = openBets.data
                .filter(bet => submittedBetIds.includes(bet.bet_producer_id))
                .reduce<ConfirmedBetMapping>((acc, bet) => {
                    const position = bet.positions?.[0];
                    acc[bet.bet_producer_id] = {
                        globalId: bet.id,
                        position,
                    };
                    return acc;
                }, {});
            return { success, betIdMapping };
        }
    } catch (e) {
        logger.warn(SBK_BETSLIP_LOG_TAG, 'bet submission poll error', e);
    }
    return { success, betIdMapping: {} };
};
